import { useMemo } from 'react';
import { useBaseConfig } from '@zurich/common/contexts';
import { useBasePath } from '@zurich/common/hooks';
import { errorViewHandler as errorViewHandlerNext } from '../components';
import { useAppInstanceContext } from '../contexts';
import { createErrorObject as createErrorObjectNext } from '../errors';
export function useAppInstance() {
    const { signIn, signOut, onSignInError, onSignOutError, createErrorObject, errorViewHandler, retrySignIn, ...appInstance } = useAppInstanceContext();
    const { withBasePath } = useBasePath();
    const { basePath, authPaths } = useBaseConfig();
    const instance = useMemo(() => ({
        ...appInstance, // leap of faith from the truly instantiated appInstance object in the project
        signIn: async () => {
            const pathName = window.location.pathname;
            const assembleBasePath = basePath === '/' ? '' : basePath;
            const url = authPaths?.redirectProtection.includes(pathName.slice(assembleBasePath.length))
                ? withBasePath(authPaths?.signIn)
                : window.location.href;
            const searchParams = new URLSearchParams(window.location.search);
            // TODO: validate searchParams url to avoid malicious use!
            const callbackUrl = searchParams.get('r') ?? url;
            try {
                await signIn(callbackUrl);
            }
            catch (error) {
                onSignInError?.(error);
            }
        },
        signOut: async (redirect, url = authPaths.signOut) => {
            try {
                await signOut(redirect, withBasePath(url));
            }
            catch (error) {
                console.error('Sign Out Error', error);
                onSignOutError?.(error);
            }
        },
        retrySignIn: async () => {
            await retrySignIn(withBasePath(authPaths.signIn));
        },
        createErrorObject: (className) => createErrorObject?.(className) ?? createErrorObjectNext(className),
        errorViewHandler: (error) => errorViewHandler?.(error) ?? errorViewHandlerNext(error),
    }), [
        appInstance,
        basePath,
        authPaths?.redirectProtection,
        authPaths.signIn,
        authPaths.signOut,
        withBasePath,
        signIn,
        onSignInError,
        signOut,
        onSignOutError,
        retrySignIn,
        createErrorObject,
        errorViewHandler,
    ]);
    return instance;
}
